"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeAuthenticationEvent = exports.publishAuthenticationEvent = void 0;
const _1 = require("./");
const factory_1 = require("./factory");
const CHANNEL_KEY = 'reauthenticationEvent';
exports.publishAuthenticationEvent = (0, factory_1.createPublishFunction)(CHANNEL_KEY, _1.ReauthenticationEvent);
exports.subscribeAuthenticationEvent = (0, factory_1.createSubscribeFunction)(CHANNEL_KEY);
//# sourceMappingURL=reauthentication.js.map